import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { CircularProgress } from '@material-ui/core';
import debounce from 'debounce-promise';
import Section from '../section/section';
import ProductList from '../product-list/product-list';
import { GET_PRODUCTS_BY_CATEGORY } from '../../queries';
import { MAX_ELEMENTS_TO_DISPLAY } from '../../constants';
import classes from './category.module.scss';

interface Iproduct {
  id: string;
  name: string;
  imagesUrls: string[];
  price: number;
  reviews: any[];
  stars: number;
}

interface IproductsResponse {
  productsByCategory: Iproduct[];
  productsCount: number;
}

const Category = ({ category }: any) => {
  const { loading, error, data, fetchMore } = useQuery(
    GET_PRODUCTS_BY_CATEGORY,
    {
      variables: {
        category: category !== 'all' ? category : null,
        prodsPerPage: MAX_ELEMENTS_TO_DISPLAY,
        offset: 0
      }
    }
  );

  useEffect(() => {
    const debouncedLoadMoreProducts = debounce(() => {
      // tslint:disable-next-line: no-shadowed-variable
      const { productsByCategory, productsCount } = data;

      const { scrollTop, offsetHeight } = document.documentElement;
      const scrollHeight = window.innerHeight + scrollTop;
      const isBottomEnd = scrollHeight === offsetHeight;

      if (isBottomEnd && productsByCategory.length < productsCount) {
        loadMoreProducts();
      }
    }, 100);

    window.addEventListener('scroll', debouncedLoadMoreProducts);
    return () =>
      window.removeEventListener('scroll', debouncedLoadMoreProducts);
  });

  if (loading) {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return <p>Помилка при завантаженні продуктів</p>;
  }

  const { productsByCategory, productsCount } = data;
  const productsWithOneImage =
    productsByCategory &&
    productsByCategory.map((product: any) => ({
      ...product,
      image: product.imagesUrls[0]
    }));

  const getTitle = (currentCategory: string, productCategories: any[]) => {
    if (currentCategory === 'all') return 'Усі пропозиції';
    // tslint:disable-next-line: no-shadowed-variable
    for (const category of productCategories) {
      if (category.value === currentCategory) return category.label;
    }
  };

  const loadMoreProducts = () => {
    fetchMore({
      variables: {
        offset: productsByCategory.length
      },
      updateQuery: (prev: IproductsResponse, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          productsByCategory: [
            ...prev.productsByCategory,
            ...fetchMoreResult.productsByCategory
          ],
          productsCount: fetchMoreResult.productsCount
        };
      }
    });
  };

  return (
    <div className={classes.category}>
      {productsByCategory && productsByCategory.length ? (
        <Section
          title={getTitle(category, productsWithOneImage[0].categories)}
          count={productsByCategory.length}
          maxLimit={productsCount}
        >
          <ProductList products={productsWithOneImage} />
        </Section>
      ) : (
        <p style={{ textAlign: 'center' }}>Немає продуктів в цій категорії</p>
      )}
    </div>
  );
};

export default Category;
